import { baseQuery } from '../baseQuery';

export const getUser = async () => {
  const { data } = await baseQuery('user-info');

  return data;
};
